<template>
  <v-card-text class="timer-to-update py-0">
    <p class="mb-0" v-if="this.showTimer() && showCountDown">
      <!-- {{ "lng_nextupdate" | translate }}: {{ countDown }}
      {{ "lng_seconds" | translate }} -->
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: "RefreshTimer",
  data() {
    return {
      countDown: 1,
      intervalInstance: undefined
    };
  },
  props: {
    // refreshTime is used to set countdown for specific secounds
    refreshTime: {
      type: Number,
      default: 0
    },
    // A prop function called in parent after the countdown is finished.
    refreshPage: {
      type: Function,
      default: undefined
    },
    //A prop to check if countdown must be shown or not
    showCountDown: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    refreshTime: function(newVal) {
      this.countDown = newVal;
    }
  },
  mounted() {
    this.countDown = this.refreshTime;
    this.setTimerInterval(this.countDown);
  },
  // vue's lifecycle funtion to called on destroy component.
  beforeDestroy() {
    clearInterval(this.intervalInstance);
  },
  methods: {
    // A Interval function to repeat the countdown
    setTimerInterval(countDownTime) {
      let time = countDownTime * 1000;
      let that = this;
      this.intervalInstance = setInterval(function() {
        time = time - 1000; //reduce each second
        that.countDown = (time / 1000) % 60;
      }, 1000);
    },

    // Clear the existing interval on reaching 0 and call the parent function for api's calling
    showTimer() {
      if (this.countDown <= 0) {
        clearInterval(this.intervalInstance);
        this.refreshPage();
        return 0;
      } else {
        return this.countDown;
      }
    }
  }
};
</script>
<style>
.timer-to-update {
  position: fixed;
  bottom: 0;
  font-size: 18px;
  color: #ff5722;
}
</style>
